/* global jQuery */
'use strict';

require('core-js/fn/array/includes');
require('core-js/fn/object/assign');

const csrf = require('public/js/lib/csrf/utils');
const utils = require('public/js/helpers/utils');

const BOT_BLOCKED_ROUTES = new Set([
	'/ajax/backorder-waitlist/subscribe',
	'/ajax/cart',
	'/ajax/csrf/token',
	'/ajax/dealers-by-distance',
	'/ajax/dealers/selected',
	'/ajax/garage/get-list',
	'/ajax/profile/status',
	'/ajax/vehicle-picker/get-garage',
]);

/**
 * @returns {void}
 */
function initBotGuard() {
	try {
		if (typeof globalThis.$ajax !== 'function' || globalThis.$ajax.__rp_bot_guard_init) {
			return;
		}

		if (!utils.isBot()) {
			return;
		}

		const original$ajax = globalThis.$ajax;

		// Short-circuit only inspects arguments[0]. The two-arg jQuery form
		// $ajax(url, settings) would place success/error in arguments[1],
		// which the bot path does not read. All current blocked-route call
		// sites use the single-object form. Non-blocked routes pass through
		// to original$ajax with all arguments intact.
		globalThis.$ajax = function rpBotGuardAjaxWrapper() {
			const opts = arguments[0];
			const url = utils.getUrlFromRequest(opts);
			const pathname = utils.getPathnameFromUrl(url);

			if (BOT_BLOCKED_ROUTES.has(pathname)) {
				const emptyResponse = {};

				if (typeof opts?.success === 'function') {
					setTimeout(() => opts.success(emptyResponse), 0);
				}

				const deferred = jQuery.Deferred();
				deferred.resolve(emptyResponse, 'success', null);
				return deferred.promise();
			}

			return original$ajax.apply(this, arguments);
		};

		globalThis.$ajax.__rp_bot_guard_init = true;
	} catch (e) {
		// silent error
	}
}

function withCsrfHeader(requestOpts) {
	if (!csrf.shouldAttachCsrfHeader(requestOpts)) {
		return requestOpts;
	}

	const token = csrf.getCsrfTokenFromMeta() || csrf.getToken();
	if (!token) {
		return requestOpts;
	}
	return csrf.withCsrfHeaderFromConfig(requestOpts, token);
}

module.exports = (requestOpts) => {
	$ajax(withCsrfHeader(requestOpts || {}));
};

module.exports.BOT_BLOCKED_ROUTES = BOT_BLOCKED_ROUTES;
module.exports.initBotGuard = initBotGuard;
